export function getNewsPage(state: any) {
    return state.news.list;
}

export function getNews(state: any) {
    return state.news.one;
}

export function isLoading(state: any) {
    return state.news.isLoading;
}
